import { gql, type TypedDocumentNode } from '@apollo/client';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { BodyS } from '@sorare/core/src/atoms/typography';
import { isType } from '@sorare/core/src/lib/gql';

import type { TaskDetailsDescription_taskInterface } from './__generated__/index.graphql.ts';

const Root = styled(BodyS)`
  display: flex;
  align-items: baseline;
  gap: var(--half-unit);
`;
export const TaskDetailsDescription = ({
  task,
}: {
  task: TaskDetailsDescription_taskInterface;
}) => {
  if (!isType(task, 'CompleteCollectionsCountTask')) {
    return null;
  }
  const { userCollectionClosestToCompletion } = task;
  const { cardCollection } = userCollectionClosestToCompletion || {};
  const { anyTeam } = cardCollection || {};
  const { name } = anyTeam || {};
  return (
    <Root>
      <FormattedMessage
        defaultMessage="{clubName} is your most advanced collection!"
        values={{
          clubName: (
            <>
              <img src={anyTeam?.pictureUrl ?? ''} alt={name} height={24} />
              <b>{name}</b>
            </>
          ),
        }}
      />
    </Root>
  );
};

TaskDetailsDescription.fragments = {
  taskInterface: gql`
    fragment TaskDetailsDescription_taskInterface on TaskInterface {
      id
      ... on CompleteCollectionsCountTask {
        id
        userCollectionClosestToCompletion {
          id
          fulfilledSlotsCount
          slotsCount
          cardCollection {
            slug
            anyTeam {
              slug
              name
              pictureUrl
            }
          }
        }
      }
    }
  ` as TypedDocumentNode<TaskDetailsDescription_taskInterface>,
};
